import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function MediaShuttleLogBody() {
    return (
        // This is meant to be placed after some lead text to introduce the fact that
        // the logs are in two different locations, or something similar
        <React.Fragment>
            <p>
                <strong>Linux</strong>: <code className="language-text">/usr/Signiant_Media_Shuttle/log</code>
                <br />
                <strong>Windows</strong>:{' '}
                <code className="language-text">C:\Program Files\Signiant Media Shuttle\log</code>
            </p>
            <p>The Signiant SDCX Server creates logs related to daily transfers and activity.</p>
            <ul>
                <li>
                    <code className="language-text">Signiant_SDCX_Server_Install.log</code> - SDCX Server installation
                </li>
                <li>
                    <code className="language-text">mediashuttle.log</code> - Media Shuttle transfer activity
                </li>
                <li>
                    <code className="language-text">dds_pc</code> - Signiant Process Control activity
                </li>
                <li>
                    <code className="language-text">dds_udp_relay</code> - Signiant UDP Relay Service for Media Shuttle
                    activity
                </li>
                <li>
                    <code className="language-text">prtcl_servers</code> - Transfer protocol information
                </li>
                <li>
                    <code className="language-text">sigfgw_logs</code> - Flight Gateway service initialization and
                    monitoring
                </li>
                <li>
                    <code className="language-text">sigfs_logs</code> - Flight Server service initialization and
                    monitoring
                </li>
                <li>
                    <code className="language-text">sigjet_logs</code> - Jet Server service initialization and
                    monitoring
                </li>
                <li>
                    <code className="language-text">tomcat</code> - Local web service activity for server registration
                    and initialization
                </li>
            </ul>
        </React.Fragment>
    );
}

MediaShuttleLogBody.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MediaShuttleLogBody);
